<template>
  <div class="unselect-box">
    <img
      :src="require('@/assets/svg/SVG/x.svg')"
      alt="Unselect"
      class="x-icon"
    >
  </div>
</template>

<script>
export default {
  name: 'UnselectMarker',
};
</script>

<style scoped>
.unselect-box {
  cursor: pointer;
  width: 12px;
  height: 12px;
  display: flex;
  align-content: center;
  justify-content: center;

}

.x-icon {
  width: 12px;
  height: 12px;
}

</style>